import React, { useState } from 'react';
import { ProductsData } from '../data/products-data'; // Veriyi import ediyoruz
import { Link, useLocation } from 'react-router-dom';

const MobileMenu = ({toggle,setToggle}) => {
  const [isSystemsMenuOpen, setIsSystemsMenuOpen] = useState(true); // SİSTEMLER dropdown aç/kapat durumu
  const [openCategoryIndex, setOpenCategoryIndex] = useState(null); // Hangi kategori açık, bunu tutar
  const location = useLocation(); // Şu anki URL'i alır
  const toggleSystemsMenu = () => {
    setIsSystemsMenuOpen(!isSystemsMenuOpen); // SİSTEMLER dropdown aç/kapat
  };

  const toggleCategory = (index) => {
    setOpenCategoryIndex(openCategoryIndex === index ? null : index); // Kategoriyi aç/kapat
  };


   // Aktif link kontrol fonksiyonu
   const isActive = (url) => {
    return location.pathname === url ? 'text-turkuaz-blue' : 'text-gray-700 hover:scale-105 transition-all duration-300';
  };

  return (
    <header className={` relative z-50 col-span-2 h-screen overflow-y-auto  bg-white   px-[5%]`}>
      <nav className="flex justify-between items-center w-full">
        {/* Diğer menü başlıkları */}
        <div className=" flex flex-col w-full space-y-2">
          <Link to="/"             className={`${isActive('/')} text-xl`}>ANASAYFA</Link>
          <Link to="/hakkimizda"  className={`${isActive('/hakkimizda')} text-xl`}>HAKKIMIZDA</Link>
          <div className="relative inline-block">
            <button
              onClick={toggleSystemsMenu}
              className="text-gray-700 hover:text-gray-900 flex items-center text-xl "
            >
              ÜRÜNLER

            </button>

            {/* SİSTEMLER dropdown içeriği, menü açıkken gösterilecek */}
            {isSystemsMenuOpen && (
              <div className="    ">
                <ul className="px-2">
                  {ProductsData.map((category, index) => (
                    <li key={category.categoryUrl}>
                      <Link 
                        to={`/products/${category.categoryUrl}`}
                        onClick={() => toggleCategory(index)} // Kategori aç/kapat
                        className={`flex justify-between w-full text-left  text-gray-700 hover:text-gray-800 ${isActive(`/urunler/${category.categoryUrl}`)} `}
                      >
                        {category.categoryName}
                       
                      </Link>
                      

                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
          {/* <a href='/images/pdf/katalog.pdf' target='_blank' className=' text-xl' >KATOLOG</a> */}
          <Link to="/iletisim"  className={`${isActive('/iletisim')} text-xl`}>İLETİŞİM</Link>
        </div>
      </nav>
    </header>
  );
};

export default MobileMenu;
